(function () {
  const productCache = {}; // handle → fetched product data

  function getRefs(flyout) {
    if (!flyout._refs) {
      flyout._refs = {
        title: flyout.querySelector(".sw-flyout__title"),
        images: flyout.querySelector(".sw-flyout__images"),
        variantInput: flyout.querySelector(".sw-flyout__variant-id"),
        atcBtn: flyout.querySelector(".sw-flyout__atc"),
        atcLabel: flyout.querySelector(".sw-flyout__atc span"),
        pdpLink: flyout.querySelector(".sw-flyout__pdp-link"),
        swatchLabel: flyout.querySelector("[data-current-swatch]"),
      };
    }
    return flyout._refs;
  }

  // Parse variants once; reuse the cached array on every subsequent call
  function getVariants(variantInput) {
    if (!variantInput._variants) {
      variantInput._variants = JSON.parse(
        variantInput.getAttribute("data-variants"),
      );
    }
    return variantInput._variants;
  }

  function setAtc(refs, available) {
    refs.atcBtn.disabled = !available;
    refs.atcLabel.textContent = available ? "ADD TO CART" : "OUT OF STOCK";
  }

  // Update only images whose src actually changed instead of rebuilding innerHTML
  function syncImages(container, newImages, title) {
    const srcs = newImages.slice(0, 3);
    const imgs = container.querySelectorAll(".sw-flyout__image-wrap img");
    srcs.forEach((src, i) => {
      if (imgs[i]) {
        if (!imgs[i].src.endsWith(src)) {
          imgs[i].src = src;
          imgs[i].alt = title;
        }
      } else {
        const wrap = document.createElement("div");
        wrap.className = "sw-flyout__image-wrap";
        wrap.innerHTML = `<img src="${src}" alt="${title}" width="500" height="625" loading="lazy">`;
        container.appendChild(wrap);
      }
    });
    for (let i = srcs.length; i < imgs.length; i++)
      imgs[i].closest(".sw-flyout__image-wrap")?.remove();
  }

  function mountStyleWith() {
    const template = document.getElementById("sw-section");
    const mount = document.getElementById("sw-section-mount");
    if (!template || !mount) return;

    mount.appendChild(template.content.cloneNode(true));
    template.remove();
  }

  mountStyleWith();
  window.addEventListener("productSwitched", mountStyleWith);

  // ── Open / close
  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest("[data-open-flyout]");
    if (openBtn) {
      openFlyout(openBtn.getAttribute("data-open-flyout"));
      return;
    }
    const closeBtn = e.target.closest("[data-close-flyout]");
    if (closeBtn) closeFlyout(closeBtn.getAttribute("data-close-flyout"));
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const open = document.querySelector('.sw-flyout[aria-hidden="false"]');
    if (open) closeFlyout(open.id);
  });

function openFlyout(id) {
  let flyout = document.getElementById(id);
  let justMounted = false;

  if (!flyout) {
    const tpl = document.querySelector(
      `template.sw-flyout-template[data-flyout-id="${id}"]`
    );
    if (tpl) {
      document.body.appendChild(tpl.content.cloneNode(true));
      flyout = document.getElementById(id);
      justMounted = true;
      if (window.StampedFn && StampedFn.loadBadges) {
        try { StampedFn.loadBadges(); } catch (e) {}
      }
    }
  }

  if (!flyout) return;

  const reveal = () => {
    flyout.setAttribute("aria-hidden", "false");
    document.body.classList.add("sw-flyout-open");
  };

  if (justMounted) {
    // Let the browser paint the closed state once, then animate to open
    requestAnimationFrame(() => requestAnimationFrame(reveal));
  } else {
    reveal();
  }
}

  function closeFlyout(id) {
    const flyout = document.getElementById(id);
    if (!flyout) return;
    flyout.setAttribute("aria-hidden", "true");
    if (!document.querySelector('.sw-flyout[aria-hidden="false"]')) {
      document.body.classList.remove("sw-flyout-open");
    }
  }

  // ── Size button → variant
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".sw-flyout__size-btn");
    if (!btn || btn.classList.contains("sw-flyout__size-btn--sold-out")) return;

    const flyout = btn.closest(".sw-flyout");
    const refs = getRefs(flyout);
    const optionIndex = parseInt(btn.dataset.optionIndex);

    flyout
      .querySelectorAll(
        `.sw-flyout__size-buttons[data-option-index="${optionIndex}"] .sw-flyout__size-btn`,
      )
      .forEach((b) => b.classList.remove("sw-flyout__size-btn--selected"));
    btn.classList.add("sw-flyout__size-btn--selected");

    const selected = Array.from(
      flyout.querySelectorAll(".sw-flyout__size-buttons"),
    ).map(
      (g) =>
        g.querySelector(".sw-flyout__size-btn--selected")?.dataset.value ??
        null,
    );

    if (selected.includes(null)) return;

    const match = getVariants(refs.variantInput).find((variant) =>
      variant.options.every((option, index) => option === selected[index]),
    );
    if (!match) return;

    refs.variantInput.value = match.id;
    setAtc(refs, match.available);
  });

  // ── Swatch → swap product content
  document.addEventListener(
    "click",
    function (e) {
      const swatch = e.target.closest(".sw-flyout .product-switch");
      if (!swatch) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const flyout = swatch.closest(".sw-flyout");
      const refs = getRefs(flyout);
      const swatchItem = swatch.closest("[swatch-product-id]");
      if (!swatchItem) return;

      const clickedProductId = swatchItem.getAttribute("swatch-product-id");
      const handle = swatch
        .getAttribute("href")
        ?.split("/products/")[1]
        ?.split("?")[0]
        .split("/")[0];
      if (!handle) return;

      function applyProduct(product) {
        refs.title.textContent = product.title.toUpperCase();
        syncImages(refs.images, product.images, product.title);

        flyout.dataset.activeProductId = clickedProductId;
        flyout.querySelectorAll("[swatch-product-id]").forEach((item) => {
          const active =
            item.getAttribute("swatch-product-id") === clickedProductId;
          item.classList.toggle("swatch__item--current", active);
          item
            .querySelector(".product-switch")
            ?.classList.toggle("is-active", active);
        });

        if (refs.swatchLabel) {
          const newTitle =
            swatch.dataset.swatchTitle || product.title.split(",").pop();
          refs.swatchLabel.textContent = newTitle;
          refs.swatchLabel.setAttribute("data-current-swatch", newTitle);
        }

        refs.variantInput.setAttribute(
          "data-variants",
          JSON.stringify(product.variants),
        );
        refs.variantInput._variants = product.variants; // update cache in place

        const firstAvailable =
          product.variants.find((variant) => variant.available) ??
          product.variants[0];
        refs.variantInput.value = firstAvailable.id;

        product.options.forEach((optionName, i) => {
          if (optionName === "Color" || optionName === "Colour") return;
          const grid = flyout.querySelector(
            `.sw-flyout__size-buttons[data-option-index="${i}"]`,
          );
          if (!grid) return;

          grid.querySelectorAll(".sw-flyout__size-btn").forEach((btn) => {
            const val = btn.dataset.value;
            const available = product.variants.some(
              (variant) => variant.options[i] === val && variant.available,
            );
            btn.classList.toggle("sw-flyout__size-btn--sold-out", !available);
            btn.classList.remove("sw-flyout__size-btn--selected");
          });

          // Pre-select the first available option for this option group
          if (firstAvailable) {
            const activeVal = firstAvailable.options[i];
            const activeBtn = grid.querySelector(
              `.sw-flyout__size-btn[data-value="${activeVal}"]`,
            );
            if (activeBtn)
              activeBtn.classList.add("sw-flyout__size-btn--selected");
          }
        });
        setAtc(refs, product.available);
        if (refs.pdpLink) refs.pdpLink.href = "/products/" + handle;
      }

      if (productCache[handle]) {
        applyProduct(productCache[handle]);
      } else {
        fetch("/products/" + handle + ".js")
          .then((r) => r.json())
          .then((product) => {
            productCache[handle] = product;
            applyProduct(product);
          });
      }
    },
    true,
  );

  // ── Add to cart (AJAX — no native form, so Amplify stays bound to the main form)
  document.addEventListener("click", function (e) {
    const atcBtn = e.target.closest(".sw-flyout__atc");
    if (!atcBtn || atcBtn.disabled) return;

    const flyout = atcBtn.closest(".sw-flyout");
    if (!flyout) return;

    const refs = getRefs(flyout);
    const variantId = refs.variantInput.value;
    if (!variantId) return;

    const originalLabel = refs.atcLabel.textContent;
    atcBtn.disabled = true;
    refs.atcLabel.textContent = "ADDING…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(() => {
        refs.atcLabel.textContent = "ADDED";
        closeFlyout(flyout.id);
        window.dispatchEvent(new Event("cart:update"));
        window.dispatchEvent(new Event("cart:open"));
        setTimeout(() => {
          refs.atcLabel.textContent = originalLabel;
          atcBtn.disabled = false;
        }, 1200);
      })
      .catch((err) => {
        console.error("[Style With] ATC error", err);
        refs.atcLabel.textContent = originalLabel;
        atcBtn.disabled = false;
      });
  });
})();
